import axios from 'axios'
import { getVisitHeaders } from './analytics'

// Use VITE_API_URL for production, empty string for local development (uses Vite proxy)
const API_BASE_URL = import.meta.env.VITE_API_URL || ''

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use((config) => {
  // Only price lookups are counted — attach anonymous visit flags to those alone,
  // so calls like /api/chains or /api/health don't consume the "first today" marker.
  if (config.url && config.url.includes('/api/products')) {
    const headers = getVisitHeaders()
    if (headers) Object.assign(config.headers, headers)
  }
  return config
})

export default api
